var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLeave = function SvgIconLeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 5.187C3 3.647 4.272 2.4 5.842 2.4h8.21c.524 0 .948.416.948.93 0 .512-.424.87-.947.87h-8.21c-.524 0-1.043.474-1.043.987v13.626c0 .513.377.987.9.987h8.353c.523 0 .947.358.947.871a.94.94 0 0 1-.947.929h-8.21C4.272 21.6 3 20.352 3 18.813z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.864 16.713v-3.556H11.7a1.2 1.2 0 0 1 0-2.4h5.163V7.202a.6.6 0 0 1 1.03-.419l5.792 4.757a.6.6 0 0 1 0 .836l-5.791 4.756a.6.6 0 0 1-1.03-.419"
  })));
};
export default SvgIconLeave;